<template>
  <footer class="footer">
    <div class="content">
      <div class="fleft">
        <img src="@/assets/img/logo_footer_zh.f421f1d9.png" alt="">
        <div class="contact">
          <span class="subtitle">鲲鹏邮箱</span>
          <a href="mailto:kunpengvpn@gmail.com" style="display: flex;">
            <img src="@/assets/img/email.502bdbde.svg" alt="">
            <span class="subtitle" style="margin-left: 10px;">kunpengvpn@gmail.com</span>
          </a>
        </div>
        <div class="contact">
          <span class="subtitle">鲲鹏Telegram</span>
          <a target="_blank" href="https://t.me/wudicms">
            <span class="subtitle">@wudicms</span>
          </a>
        </div>
        <p>版权所有 © 2023 鲲鹏VPN 团队</p>
      </div>
      <div class="fright">
        <div class="fritem">
          <h3>下载客户端</h3>
          <span class="no-select" @mousedown.prevent @click="godown('Windows')">PC 版本</span>
          <span class="down-tip">PC 最低兼容 Windows 10</span>
          <span class="no-select" @mousedown.prevent @click="godown('Android')">Android 版本</span>
          <span class="no-select" @mousedown.prevent @click="godown('iOS')">iOS 登录</span>
          <span class="no-select" @mousedown.prevent @click="godown('Mac')">Mac 版本</span>
        </div>
        <div class="fritem">
          <h3>关于鲲鹏</h3>
          <span @click="goUrl('promotion')">推广赚现金</span>
          <span @click="goUrl('termservice')">服务条款</span>
          <span @click="goUrl('privacy')">隐私权政策</span>
          <span @click="goUrl('registerterm')">注册协议</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import clientDownload from '@/mixins/clientDownload'

export default {
  mixins: [clientDownload],
}
</script>

<style scoped>
@import url(../assets/css/footer.css);
</style>
